import { ITranslations } from 'types/common';
import { ParserFormTransFields } from './types';
import en from 'translations/en/parserForm.json';
import pl from 'translations/pl/parserForm.json';
import sl from 'translations/sl/parserForm.json';

export const parserFormTranslations: ITranslations<ParserFormTransFields> = {
  name: 'parserForm',
  en,
  pl,
  sl,
};
